/* global componentHandler */

/**
 * Could show and hide an message Box with title, text and n buttons with callback functions.
 * @type object
 */
var MsgBox = {
  /**
   * Shows the message Box.
   * @param {object} data
   * title: string, text: string, buttons: [{title: string, function: function, (accent: boolean)}]<br>
   * Buttons with <i>accent: true</i> have the color.second as text color.
   * @returns {undefined}
   */
  show: function (data) {
    var that = this;

    //create node
    var wrapper = document.createElement("div");
    wrapper.classList.add("msgBox");
    wrapper.addEventListener("click", function (e) {
      if (e.target === this) that.hide();
    });

    //add hide function to node
    wrapper.MsgBox = {
      hide: that.hide,
    };

    //box
    var nodeHTML =
      '<div class="box mdl-card mdl-shadow--2dp">' +
      '<button class="close mdl-button mdl-js-button mdl-button--icon"><i class="material-icons">close</i></button>' +
      '<div class="mdl-card__title">' +
      '<h2 class="mdl-card__title-text">' +
      data.title +
      "</h2>" +
      "</div>" +
      '<div class="mdl-card__supporting-text">' +
      data.text +
      "</div>" +
      '<div class="mdl-card__actions mdl-card--border">' +
      "</div>";
    wrapper.insertAdjacentHTML("beforeEnd", nodeHTML);
    var box = wrapper.children[0];

    //close button
    box.children[0].addEventListener("click", that.hide);

    //buttons
    var mdlActionsWrapper = box.children[3];
    if (data.buttons === undefined) data.buttons = [];
    for (var i = 0, len = data.buttons.length; i < len; i++) {
      var buttonData = data.buttons[i];

      //button node
      var button = document.createElement("button");
      button.classList.add("mdl-button", "mdl-js-button");
      if (buttonData.accent) button.classList.add("mdl-button--accent");
      else button.classList.add("mdl-button--colored");
      button.textContent = buttonData.title;

      //eventListener
      button.addEventListener("click", that.hide);
      if (typeof buttonData.function === "function")
        button.addEventListener("click", buttonData.function);

      //add button to box
      mdlActionsWrapper.appendChild(button);
    }

    //if no buttons added, remove wrapper
    if (mdlActionsWrapper.children.length === 0)
      box.removeChild(mdlActionsWrapper);

    //blur content
    var bodyChildren = document.body.children;
    for (var i = 0, len = bodyChildren.length; i < len; i++) {
      var child = bodyChildren[i];
      child.style.webkitFilter = "blur(3px)";
      child.style.filter = "blur(3px)";
    }

    //append to body
    document.body.appendChild(wrapper);

    componentHandler.upgradeElement(wrapper);
  },
  /**
   * Hides the message box and unbind the event listener
   * @returns {undefined}
   */
  hide: function () {
    //remove box
    var node = document.querySelector("body > .msgBox");
    document.body.removeChild(node);

    //unblur content
    var bodyChildren = document.body.children;
    for (var i = 0, len = bodyChildren.length; i < len; i++) {
      var child = bodyChildren[i];
      child.style.webkitFilter = null;
      child.style.filter = null;
    }
  },
};
